import { Box, Input, Text } from "@showitinc/showit-wc";
import getSlug from "speakingurl";
import { _ } from "lodash";
import React from "react";
import { Map } from "immutable";
import DesignUtils from "../../../utils/DesignUtils";
import styles from "./SiteSettingsModal.module.css";
import ValidationUtils from "../../../utils/ValidationUtils";

const VanityView = ({ siteSettings, isValid, setIsValid, appConfig, onChange }) => {
  const subdomain = siteSettings.getIn(["site", "subdomain"], "");
  const subDomainName = _.isEmpty(subdomain)
    ? DesignUtils.encodeKeyForSubdomain(siteSettings.getIn(["site", "key"]))
    : subdomain;

  const vanityUrl = `https://${subDomainName}.${appConfig.siteDomain}`;
  const previewUrl = `https://${subDomainName}.${appConfig.previewDomain}`;

  const errorObj = Map.isMap(siteSettings) ? siteSettings.get("error") : null;
  const subdomainError = errorObj?.getIn?.(["fields", "subdomain"]) || null;

  const _updateSubdomainValue = (propInfo) => {
    const updatedPropInfo = {
      ...propInfo,
      value: getSlug(propInfo.detail.value, { custom: { _: "-" } }),
      label: "Vanity URL Slug",
      name: "site.subdomain",
    };

    onChange(updatedPropInfo);

    const validation = _validateStr(updatedPropInfo);

    if (validation.valid !== isValid) {
      setIsValid(validation.valid);
    }
  };

  const _validateStr = (data) => {
    const result = {
      valid: true,
      message: "",
    };

    if (ValidationUtils.isEmptyStr(data.value)) {
      result.valid = false;
      result.message = `${data.label} cannot be empty`;
    }

    return result;
  };

  return (
    <Box px={3} py={2}>
      <Text>
        The Vanity URL Slug is used to provide a unique Showit URL for testing purposes, like{" "}
        https://my-website.{appConfig.siteDomain}. It does not affect your custom domain name.
      </Text>
      <Box pt={2}>
        <Input
          className={styles["vanity-url-input"]}
          label="Vanity URL Slug"
          value={subdomain}
          onSIInput={_updateSubdomainValue}
          onValidate={_validateStr}
          longLabel
        />
        {(!subdomain || subdomainError) && (
          <span className={styles["vanity-url-error"]}>
            {!subdomain ? "Vanity URL must not be empty" : subdomainError}
          </span>
        )}
      </Box>
      <Box py={2}>
        <Text>Vanity Publish URL</Text>
        <a href={vanityUrl} rel="noreferrer" target="_blank" className={styles["domain-name-text"]}>
          {vanityUrl}
        </a>
      </Box>
      <Text>Preview URL</Text>
      <a href={previewUrl} rel="noreferrer" target="_blank" className={styles["domain-name-text"]}>
        {previewUrl}
      </a>
    </Box>
  );
};

export default VanityView;
